import { ISpacing } from './spacing.types';

const spacing: ISpacing = {
  // s1: '0.25rem', // 4px
  // s2: '0.5rem', // 8px
  // s3: '0.75rem', // 12px
  // s4: '1rem', // 16px
  // s5: '1.5rem', // 24px
  // s6: '2rem', // 32px
  // s7: '2.5rem', // 40px
  // s8: '3rem', // 48px
  // s9: '4rem', // 64px
  // s10: '5rem', // 80px

  s1: '4px', // 4px
  s2: '8px', // 8px
  s3: '12px', // 12px
  s4: '16px', // 16px
  s5: '24px', // 24px
  s6: '32px', // 32px
  s7: '40px', // 40px
  s8: '48px', // 48px
  s9: '64px', // 64px
  s10: '80px', // 80px
};

export default spacing;
